<template>
  <div class="marketing-credits-list">
    <v-data-table :headers="headers"
                  :items="reportList"
                  :loading="loading"
                  :hide-actions="true"
                  :no-data-text="$t('message.creditManagement.message.noCreditsRegistered')"
                  :no-results-text="$t('message.generics.message.noData')">

      <template slot="items"
                slot-scope="props">

        <marketing-credits-list-item :item="props.item" />

      </template>
    </v-data-table>

    <infinite-loading :identifier="infiniteId"
                      @infinite="fetchList">
      <div slot="no-results"></div>
      <div slot="no-more"></div>
    </infinite-loading>

  </div>
</template>

<script>
import MarketingCreditsListItem from "@components/modules/marketing/generic/credits/list/item/MarketingCreditsListItem";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    InfiniteLoading,
    MarketingCreditsListItem,
  },
  data() {
    return {
      reportList: [],
      headers: [
        { text: this.$t('message.generics.message.description'), value: "description", sortable: true },
        { text: this.$t('message.monitoring.message.date'), value: "creationDate", sortable: true },
        { text: this.$t('message.generics.message.amount'), value: "amount", sortable: true },
        { text: this.$t('message.creditManagement.message.expirationDate'), value: "expirationDate", sortable: true },
      ],
      loading: false,
      page: 0,
      infiniteId: +new Date(),
    };
  },

  props: {
    channelType: {
      type: String,
      required: true,
    },
  },

  created() {
    //this.fetchList();
  },

  computed: {},

  watch: {},

  methods: {
    async fetchList($state) {
      this.loading = true;

      const reportList = await this.$api.marketing.channel.report.list({
        page: this.page,
        channelType: this.channelType,
      });

      if (reportList.length) {
        this.page += 1;

        this.reportList.push(...reportList);

        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
